function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgRankingCalendari = function SvgRankingCalendari(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "nonzero",
    d: "M17.847 4.44h-.86V3.276a.775.775 0 0 0-1.551 0V4.44h-2.63V3.276a.775.775 0 0 0-1.551 0V4.44H8.626V3.276a.775.775 0 0 0-1.551 0V4.44h-.861A2.72 2.72 0 0 0 3.5 7.153v11.634a2.716 2.716 0 0 0 2.714 2.714h11.633a2.716 2.716 0 0 0 2.714-2.714V7.153a2.72 2.72 0 0 0-2.714-2.713M6.214 5.99h.861v1.163a.775.775 0 0 0 1.551 0V5.99h2.629v1.163a.775.775 0 0 0 1.551 0V5.99h2.63v1.163a.77.77 0 0 0 .472.742.77.77 0 0 0 .607 0 .77.77 0 0 0 .472-.742V5.99h.86a1.17 1.17 0 0 1 .822.341c.218.218.341.514.341.822v2.112H5.051V7.153A1.17 1.17 0 0 1 6.214 5.99m11.633 13.96H6.214a1.164 1.164 0 0 1-1.163-1.163v-7.974H19.01v7.974a1.164 1.164 0 0 1-1.163 1.163"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRankingCalendari);
export default ForwardRef;